import { addDays, differenceInDays, format, isSameWeek, isToday, isYesterday } from "date-fns";

export const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];

export const getMonthName = (month: number): string => {
    return monthNames[month - 1];
};

export const getToday = (): string => {
    return format(new Date(), "yyyy-MM-dd") + "T23:59:59.999Z";
};

export const getTomorrow = (): string => {
    const tomorrowDate = addDays(new Date(), 1);
    return format(tomorrowDate, "yyyy-MM-dd") + "T23:59:59.999Z";
};

export const getScheduledForUTC = (date: string): string => {
    const [year, month, day] = date.split("-").map((x) => Number(x));
    return format(new Date(year, month - 1, day), "yyyy-MM-dd") + "T23:59:59.999Z";
};

export const isScheduledForSameWeek = (scheduledFor: string): boolean => {
    const today = new Date(getToday());
    const scheduled = new Date(scheduledFor);

    return isSameWeek(today, scheduled);
};

export const getActiveMessage = (lastActive: string | undefined): string => {
    if (!lastActive) return "";

    const utcDate = new Date(lastActive.split("T")[0] + "T23:59:59.999Z");

    const todayUtc = new Date(format(new Date(), "yyyy-MM-dd") + "T23:59:59.999Z");

    if (isToday(utcDate)) {
        return "today";
    }

    if (isYesterday(utcDate)) {
        return "yesterday";
    }

    const dayDifference = Math.abs(differenceInDays(utcDate, todayUtc));

    if (dayDifference < 7) {
        return `${dayDifference} days ago`;
    }

    const weeks = Math.floor(dayDifference / 7);
    return `${weeks} week${weeks > 1 ? "s" : ""} ago`;
};

/** Uses yyyy-MM-dd */
export const longLocalizedDate = (date: string, form = "PP"): string => {
    const actualDate = date.split("T")[0].split("-");

    return format(new Date(Number(actualDate[0]), Number(actualDate[1]) - 1, Number(actualDate[2])), form);
};

export const getDatePartsISO8601 = (date: string): { year: string; month: string; day: string } => {
    const [year, month, day] = date.split("-");
    return { day, month, year };
};

export const convertUTCToLocalTimeZone = (date: string): Date => {
    return new Date(date + "Z");
};

export const isValidDate = (y?: string, m?: string, d?: string): boolean => {
    const parseY = !isNaN(Number(y));
    const parseM = !isNaN(Number(m));
    const parseD = !isNaN(Number(d));

    return parseY && parseM && parseD;
};

export const stringDateCompare = (date1: string, date2: string): number => {
    return new Date(date1).getTime() - new Date(date2).getTime();
};
